// Interfaces
import { Store } from '@ngrx/store';
// Constants
import { CHART_INTERACTIVE_MODE, CHART_PRESENTATION_MODE } from 'ChartApp/ts/features/charts-shared/constants';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
const _c0 = a0 => ({ "current": a0 });
export class ChartTypeToggleComponent {
    constructor(store) {
        this.store = store;
        this.INTERACTIVE_MODE = CHART_INTERACTIVE_MODE;
        this.PRESENTATION_MODE = CHART_PRESENTATION_MODE;
        this.chartType = CHART_INTERACTIVE_MODE;
        this.mapStateToComponent = (state) => {
            this.chartType = state[state.appStateSliceKey].chartType;
        };
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    toggleChartType(event) {
        event.preventDefault();
        const newChartType = this.chartType === CHART_INTERACTIVE_MODE ? CHART_PRESENTATION_MODE : CHART_INTERACTIVE_MODE;
        this.store.dispatch(this.setChartTypeAction({ chartType: newChartType }));
    }
}
ChartTypeToggleComponent.ɵfac = function ChartTypeToggleComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ChartTypeToggleComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
ChartTypeToggleComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChartTypeToggleComponent, selectors: [["ycn-chart-type-toggle"]], inputs: { setChartTypeAction: "setChartTypeAction" }, standalone: false, decls: 5, vars: 8, consts: [[1, "btn-group", "switch"], [1, "btn", "btn-outline", "btn-off", 3, "click"], [1, "btn", "btn-outline", "btn-on", 3, "click"]], template: function ChartTypeToggleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "a", 1);
        i0.ɵɵlistener("click", function ChartTypeToggleComponent_Template_a_click_1_listener($event) { return ctx.toggleChartType($event); });
        i0.ɵɵtext(2, "Off");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "a", 2);
        i0.ɵɵlistener("click", function ChartTypeToggleComponent_Template_a_click_3_listener($event) { return ctx.toggleChartType($event); });
        i0.ɵɵtext(4, "On");
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵclassMap(i0.ɵɵpureFunction1(4, _c0, ctx.chartType === ctx.INTERACTIVE_MODE));
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap(i0.ɵɵpureFunction1(6, _c0, ctx.chartType === ctx.PRESENTATION_MODE));
    } }, encapsulation: 2 });
